import type { SVGProps } from 'react'

type Props = Omit<SVGProps<SVGSVGElement>, 'className'> & { className?: string }

const HistoryIcon = ({ className, ...props }: Props) => (
    <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className={className}
        {...props}
    >
        <path
            d="M5.02659 8.73239C5.75875 7.09614 7.01925 5.7532 8.6059 4.91898C10.1925 4.08476 12.0134 3.8076 13.7764 4.13195C15.5394 4.4563 17.1424 5.36337 18.3282 6.70767C19.5141 8.05197 20.2141 9.75559 20.3159 11.5453C20.4178 13.335 19.9157 15.107 18.89 16.5772C17.8644 18.0474 16.3747 19.1305 14.6598 19.6528C12.945 20.1751 11.1045 20.1063 9.43344 19.4575C7.76237 18.8088 6.35763 17.6175 5.44453 16.0749"
            stroke="currentColor"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M3.60922 5.40563L4.06575 8.71336C4.14849 9.3128 4.74049 9.70198 5.32361 9.54027L8.02899 8.78997"
            stroke="currentColor"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M12.5 8.5V11.9534C12.5 12.3321 12.286 12.6784 11.9472 12.8478L9.5 14.0714"
            stroke="currentColor"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </svg>
)

export default HistoryIcon
